<template>
  <div>
    <LinkBankAccount :companyId="$route.query.companyId ? $route.query.companyId :  this.company.id" />
    <MasterLayout>
      <div class="dashboard_first_row pt-4 pb-3 pl-4 pr-4">
        <div class="row align-items-center white-bg py-3">
          <div class="col-md-1 remove-right-padding col-center-flex">
            <div class="square-icon-wrapper small sky-bg">
              <img src="@/assets/img/bank-building (2).svg" width="35" />
            </div>
          </div>
          <div class="col-md-9">
            <h4 class="primary-color font-600">{{ $t('text.cBank.account.title')}}</h4>
            <p class="light-grey-text mt-3">
              {{ $t('text.cBank.account.description')}}<br />
            </p>
          </div>
          <div class="col-md-2">
            <button class="ep-btn ep-primary" @click="linkBankModal">
              {{ $t('text.cBank.account.addBank')}}
            </button>
          </div>
        </div>
      </div>
      <div class="new-row mt-3">
        <h6 class="primary-color mt-3" v-if="showLinkedBanks">
          {{ $t('text.cBank.account.accountList')}}
        </h6>
      </div>
      <section class="row mt-3 w-100" v-if="showLoader">
        <div
          class="col-md-3 position-relative mt-3"
          v-for="(c, i) in 12"
          :key="i"
        >
          <div class="card-loader"></div>
        </div>
      </section>
      <div class="p-2" v-if="banks && banks.length > 0">
        <div class="new-row">
          <div class="ep-card green-color p-1 text-center br-5">
            <p class="m-0 primary-color">
              <span class="mr-3">
                <img src="@/assets/img/link.svg" width="25" />
              </span>
              {{ $t('text.cBank.account.iconInfo')}}
            </p>
          </div>
        </div>
        <div class="row ml-2">
          <div class="col-md-4" v-for="acc in banksArr" :key="acc.id">
            <div class="linked-account-wrapper">
              <div class="linked-acounts-container position-relative">
                <div class="position-absolute">
                  <div class="linked-icon-container" v-if="acc.linked">
                    <img src="@/assets/img/link.svg" width="25" />
                  </div>
                </div>
                <div
                  class="
                    d-flex
                    justify-content-between
                    align-items-center
                    mt-5
                    pt-3
                  "
                >
                  <div>
                    <span class="font-600 primary-color" v-if="!acc.iconUrl">
                      {{ acc.name }}
                    </span>
                    <img
                      :src="`${
                        acc.iconUrl
                          ? acc.iconUrl
                          : require('@/assets/img/bank-building (2).svg')
                      }`"
                      width="40"
                      v-if="acc.iconUrl"
                    />
                  </div>
                  <p class="primary-color m-0 font-600">
                    {{ acc.accountName }}
                  </p>
                </div>
                <div class="d-flex justify-content-between mt-3">
                  <p class="font-600 primary-color">{{ acc.accountNumber }}</p>
                  <h6
                    class="color-red font-600 cursor-pointer"
                    @click="removeBank(acc)"
                  >
                  {{ $t('text.cBank.account.removeBank')}}
                  </h6>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="">
              <div class="linked-account-muted">
                <div class="mx-auto text-center">
                  <img src="@/assets/img/bank-disabled.svg" width="25" />
                  <p class="text-muted mt-4">
                    {{ $t('text.cBank.account.accountsAdded')}}
                  </p>
                  <p
                    class="primary-color m-0 cursor-pointer"
                    @click="linkBankModal"
                  >
                  {{ $t('text.cBank.account.addBank')}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="empty-info-wrapper new-row"
        v-if="!showLoader && banksArr && banksArr.length < 1"
      >
        <img src="@/assets/img/bank-building (2) (2).svg" width="50" />
        <p class="light-grey-text mt-5">
          {{ $t('text.cBank.account.noBankLinked')}}
        </p>
        <small class="light-grey-text"
          >  {{ $t('text.cBank.account.accountDisplayed')}}</small
        >
        <div class="mt-5">
          <button class="ep-btn ep-secondary" @click="linkBankModal">
            {{ $t('text.cBank.account.addBank')}}
          </button>
        </div>
      </div>
      <!-- <TableLoader :showLoader="showLoader"></TableLoader> -->
    </MasterLayout>
  </div>
</template>
<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  groupAggregates,
} from "@syncfusion/ej2-vue-grids";
import Temp from "@/components/Templates/invoices";
import DateTemp from "@/components/Templates/dateTemp";
import Paginator from "@/components/Paginator.vue";
import invoiceTemp from "@/components/Templates/list_of_invoices_template.vue";
import VueMomentsAgo from "vue-moments-ago";
import LinkBankAccount from "@/components/modals/linkBankAccount.vue";

import Jquery from "jquery";
let $ = Jquery;

export default {
  title: "Link Bank Account:: Epump Portal",
  components: {
    MasterLayout,
    TableLoader,
    Paginator,
    LinkBankAccount,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search],
  },
  data() {
    return {
      showLinkedBanks: false,
      banks: null,
      branch: {},
      bankNames: null,
      branchId: null,
      showLoader: true,
      bankList: null,
      company: "",
      companyBanks: null,
      banksArr: [],
    };
  },
  computed: {
    linkedBanks() {
      return this.banks.filter((bank) => bank.linked === true);
    },
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getBankList();
      }
    },
    bankList(bankList) {
      this.getBankAccts();
    },
    banks() {
      const bankList = [...this.bankList];
      this.banks.forEach((bank) => {
        const bankIndex = this.bankList.findIndex(
          (bl) => bl.bankName === bank.name
        );
        if (bankIndex > -1) {
          bank.iconUrl = this.bankList[bankIndex].iconUrl;
        } else if (bank.name == "GTBank") {
          const bankObj = this.bankList.filter(
            (bl) => bl.bankName == "Guaranty Trust Bank"
          )[0];
          bank.iconUrl = bankObj.iconUrl;
        } else {
          bank.iconUrl = null;
        }
      });
      this.banksArr = this.banks;
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if(this.$route.query.companyId){
      this.getBankList();
    }
    this.$eventHub.$on("refreshLinkedBankAccount", () => {
      this.getBankList();
    });
  },
  mounted() {
    
  },
  methods: {
    removeBank(account) {
      const confirmPrompt = confirm( this.$t('text.cBank.confirmMsg')
      );
      if (confirmPrompt) {
        this.axios
          .get(
            `${configObject.apiBaseUrl}/Company/RemoveBankAccount/${account.id}/${this.$route.query.companyId ? this.$route.query.companyId :  this.company.id}`,
            configObject.authConfig()
          )
          .then(() => {
            this.getBankAccts();
            this.$toast.open({
              message: this.$t('text.cBank.removedSuccess'),
              type: "success",
              duration: 5000,
            });
          })
          .catch((error) => {});
      }
    },
    // getBanks() {
    //   this.axios
    //     .get(
    //       `${configObject.apiBaseUrl}/Branch/Banks`,
    //       configObject.authConfig()
    //     )
    //     .then((response) => {
    //       this.bankNames = response.data;
    //     })
    //     .catch((error) => {});
    // },
    getBankList() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Utilities/BankList?ApplyPaging=false&companyId=${this.$route.query.companyId ? this.$route.query.companyId :  this.company.id}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.bankList = response.data.data;
        })
        .catch((error) => {});
    },
    linkBankModal() {
      this.$modal.show("linkBankAccount");
    },
    getBankAccts() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/company/BankAccounts/${this.$route.query.companyId ? this.$route.query.companyId :  this.company.id}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.forEach((el) => {
            el.iconUrl = "";
            const nameArr = el.accountName.split(" ");
            if (nameArr.length > 1) {
              el.accountName = `${nameArr[0]}.${nameArr[1].charAt(0)}`;
            }
          });
          this.showLoader = false;
          this.showLinkedBanks = true;
          this.banks = response.data;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>